/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-06-19 10:24:08
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-07-11 11:48:59
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\core\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory } from 'vue-router';
import { routes, /* beforeEach,  */ afterEach } from '@/config/router.js';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// router.beforeEach(beforeEach)

router.afterEach(afterEach);

export default router;
